import { HttpErrorResponse } from '@angular/common/http';
import { ValidationError } from './../types/response';

/**
 * @deprecated - error parsing is done in the interceptor
 */
export function errorTaskParser(error: HttpErrorResponse): string {
  if (error?.error?.Errors) {
    const errors = error.error.Errors?.map((er: { errorMessage: string }) => er.errorMessage).join('\n');

    return errors;
  }

  if (error.error.detail) return error.error.detail;

  return error.toString();
}

/**
 * @deprecated - error parsing is done in the interceptor
 */
export function errorParserByKey(error: HttpErrorResponse): string[] {
  const errorMessages: string[] = [];
  if (error.error.Errors) {
    const errors: ValidationError[] = error.error.Errors;
    errors.forEach((error: ValidationError) => {
      errorMessages.push(error.errorCode);
    });
  }

  return errorMessages;
}

/**
 * @deprecated - error parsing is done in the interceptor
 */
export function parseValidationErrorMessage(error: HttpErrorResponse): string[] {
  const errorMessages: string[] = [];
  if (error.error?.validationErrors) {
    const errors: ValidationError[] = error.error.validationErrors;
    errors.forEach((error: ValidationError) => {
      errorMessages.push(`<b>${error.identifier}</b> -${error.errorMessage}`);
    });
  }

  return errorMessages;
}
